// Vuetify hands back '' when a number field is cleared, and Number('') is 0 — which would
// quietly save a zero threshold instead of failing a required-field check. Route every
// numeric form field through here so a blank stays blank (NaN) all the way to validation.
export function numericFieldValue(value) {
  if (value === '' || value === null || typeof value === 'undefined') return NaN
  return Number(value)
}
